import { customColumns } from '~/models/query';
import { BaseController } from '~/utils/base-controller';

/**
 * @implements {angular.IController}
 */
export default class PieChartSettings extends BaseController {
	// bindings
	/** @type {Dashboard.PieChartWidgetOptions} */
	widget

	parent

	/** @type {Knitiv.Scope} */
	$scope

	/* @ngInject */
	// eslint-disable-next-line no-useless-constructor
	constructor(
		$injector,

		$scope,
	) {
		super($injector);

		this.$scope = $scope;

		/** @type {Dashboard.PieChartWidgetOptions['options']['data']} */
		this.settings = {
			column: 'K_NODE;PERSON',
		};
	}

	allowedColumns() {
		return this.widget.query.select.filter(({ type }) => !customColumns.includes(type));
	}

	$onInit() {
		if (this.widget?.options?.data) {
			this.settings = { ...this.widget.options.data };
		}

		this.parent.widgetData = this.settings;

		this.$scope.$watch(() => this.settings.column, (newValue, oldValue) => {
			if (newValue !== oldValue) {
				this.parent.widgetData = this.settings;

				if (this.settings.column) {
					this.parent.isValid = true;
				}
			}
		});
	}
}
